import { useTranslation } from 'react-i18next';

interface AlertProps {
  type: 'error' | 'success' | 'info';
  message: string;
  onClose?: () => void;
}

const STYLES: Record<AlertProps['type'], { bg: string; icon: string }> = {
  error: { bg: '#e84b3d', icon: 'fa-exclamation-triangle' },
  success: { bg: '#2dcc6f', icon: 'fa-check-circle' },
  info: { bg: '#224266', icon: 'fa-info-circle' },
};

/** Caixa de mensagem consistente com o visual das telas públicas. */
export function Alert({ type, message, onClose }: AlertProps) {
  const { t } = useTranslation();
  const s = STYLES[type];
  const titles: Record<AlertProps['type'], string> = {
    error: t('views.layouts.home.attention', 'Atenção!'),
    success: t('views.registration.alert.success_title', 'Tudo certo!'),
    info: t('views.registration.alert.info_title', 'Aviso'),
  };
  return (
    <div
      role={type === 'error' ? 'alert' : 'status'}
      aria-live={type === 'error' ? 'assertive' : 'polite'}
      className="relative flex items-start gap-3 mb-4 py-[12px] px-[15px] text-white rounded"
      style={{ backgroundColor: s.bg }}
    >
      <i className={`fa ${s.icon} text-[18px] mt-[2px] shrink-0`} aria-hidden="true"></i>
      <div className="flex-1 pr-4">
        <strong className="block font-semibold text-[14px] leading-[1.4] tracking-[0.01em]">{titles[type]}</strong>
        <span className="block font-medium text-[13px] leading-[1.5]">{message}</span>
      </div>
      {onClose && (
        <button
          type="button"
          onClick={onClose}
          aria-label={t('common.close', 'Fechar')}
          className="absolute top-[8px] right-[10px] border-0 cursor-pointer text-[20px] leading-none text-white hover:text-white opacity-70 hover:opacity-100 bg-transparent"
        >
          <span aria-hidden="true">×</span>
        </button>
      )}
    </div>
  );
}
